import { combineReducers } from "redux";
import _ from "lodash";
import { API } from "../../../../const";
import { Service } from "../../../service/service";
import {
  OPEN_SNACKBAR_ERROR,
  OPEN_SNACKBAR_SUCCESS,
} from "../../../../reducers";
import { unAuthorized } from "../../../auth/Auth.ducks";

export const GET_SECTIONS_PENDING = "GET_SECTIONS_PENDING";
export const GET_SECTIONS_REJECTED = "GET_SECTIONS_REJECTED";
export const GET_SECTIONS_FULFILLED = "GET_SECTIONS_FULFILLED";

export const ADD_SECTION_PENDING = "ADD_SECTION_PENDING";
export const ADD_SECTION_REJECTED = "ADD_SECTION_REJECTED";
export const ADD_SECTION_FULFILLED = "ADD_SECTION_FULFILLED";

export const UPDATE_SECTION_PENDING = "UPDATE_SECTION_PENDING";
export const UPDATE_SECTION_REJECTED = "UPDATE_SECTION_REJECTED";
export const UPDATE_SECTION_FULFILLED = "UPDATE_SECTION_FULFILLED";

export const DELETE_SECTION_PENDING = "DELETE_SECTION_PENDING";
export const DELETE_SECTION_REJECTED = "DELETE_SECTION_REJECTED";
export const DELETE_SECTION_FULFILLED = "DELETE_SECTION_FULFILLED";

const loading = (state = false, { type }) => {
  switch (type) {
    case GET_SECTIONS_PENDING:
    case ADD_SECTION_PENDING:
    case UPDATE_SECTION_PENDING:
    case DELETE_SECTION_PENDING:
      return true;
    case GET_SECTIONS_FULFILLED:
    case GET_SECTIONS_REJECTED:
    case ADD_SECTION_FULFILLED:
    case ADD_SECTION_REJECTED:
    case UPDATE_SECTION_FULFILLED:
    case UPDATE_SECTION_REJECTED:
    case DELETE_SECTION_FULFILLED:
    case DELETE_SECTION_REJECTED:
      return false;
    default:
      return state;
  }
};

const error = (state = null, { type, payload }) => {
  switch (type) {
    case GET_SECTIONS_PENDING:
    case GET_SECTIONS_FULFILLED:
    case ADD_SECTION_PENDING:
    case ADD_SECTION_FULFILLED:
    case UPDATE_SECTION_PENDING:
    case UPDATE_SECTION_FULFILLED:
    case DELETE_SECTION_PENDING:
    case DELETE_SECTION_FULFILLED:
      return null;
    case GET_SECTIONS_REJECTED:
    case ADD_SECTION_REJECTED:
    case UPDATE_SECTION_REJECTED:
    case DELETE_SECTION_REJECTED:
      return payload;
    default:
      return state;
  }
};

const data = (state = [], { type, payload }) => {
  switch (type) {
    case GET_SECTIONS_FULFILLED:
      return _.isEmpty(payload.data) ? [] : payload.data;
    default:
      return state;
  }
};

export default combineReducers({ loading, error, data });

const handleError = (dispatch, err, type) => {
  let message = !_.isEmpty(err.response) ? err.response.data.message : null;
  dispatch({ type: OPEN_SNACKBAR_ERROR, payload: message });
  dispatch({ type, payload: err });
  if (err && err.response && err.response.status === 401) {
    dispatch(unAuthorized());
  }
};

export const getSections = (tok) => {
  return (dispatch) => {
    dispatch({ type: GET_SECTIONS_PENDING });
    const response = Service.get(`${API}api/creche/sections`, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      dispatch({ type: GET_SECTIONS_FULFILLED, payload: res });
    });
    response.catch((err) => handleError(dispatch, err, GET_SECTIONS_REJECTED));
  };
};

export const addSection = (tok, sectionData) => {
  return (dispatch) => {
    dispatch({ type: ADD_SECTION_PENDING });
    const response = Service.post(`${API}api/creche/sections`, sectionData, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      dispatch({ type: ADD_SECTION_FULFILLED, payload: res });
      dispatch({ type: OPEN_SNACKBAR_SUCCESS });
      dispatch(getSections(tok));
    });
    response.catch((err) => handleError(dispatch, err, ADD_SECTION_REJECTED));
  };
};

export const updateSection = (tok, sectionId, sectionData) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_SECTION_PENDING });
    const response = Service.put(
      `${API}api/creche/sections/${sectionId}`,
      sectionData,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      dispatch({ type: UPDATE_SECTION_FULFILLED, payload: res });
      dispatch({ type: OPEN_SNACKBAR_SUCCESS });
      dispatch(getSections(tok));
    });
    response.catch((err) =>
      handleError(dispatch, err, UPDATE_SECTION_REJECTED)
    );
  };
};

export const assignEnfantSection = (tok, enfantId, sectionId) => {
  return (dispatch) => {
    const response = Service.put(
      `${API}api/creche/enfants/${enfantId}/section`,
      { sectionId },
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then(() => {
      dispatch({ type: OPEN_SNACKBAR_SUCCESS });
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: OPEN_SNACKBAR_ERROR, payload: message });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};

export const removeEnfantSection = (tok, enfantId) => {
  return (dispatch) => {
    const response = Service.deleteOne(
      `${API}api/creche/enfants/${enfantId}/section`,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then(() => {
      dispatch({ type: OPEN_SNACKBAR_SUCCESS });
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: OPEN_SNACKBAR_ERROR, payload: message });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};

export const deleteSection = (tok, sectionId) => {
  return (dispatch) => {
    dispatch({ type: DELETE_SECTION_PENDING });
    const response = Service.deleteOne(
      `${API}api/creche/sections/${sectionId}`,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      dispatch({ type: DELETE_SECTION_FULFILLED, payload: res });
      dispatch({ type: OPEN_SNACKBAR_SUCCESS });
      dispatch(getSections(tok));
    });
    response.catch((err) =>
      handleError(dispatch, err, DELETE_SECTION_REJECTED)
    );
  };
};
